import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { AccountGroup } from "@/types/account-mapping-api";
import { group } from "console";
import { useEffect, useState } from "react";

interface CreateEditAccountGroupDialogProps {
  open: boolean;
  groupToEdit: AccountGroup | null;
  onOpenChange: (open: boolean) => void;
  onCreateAccountGroup: (name: string) => void;
  onEditAccountGroup: (accountGroup: AccountGroup) => void;
}

export const CreateEditAccountGroupDialog = ({
  open,
  onOpenChange,
  onCreateAccountGroup,
  onEditAccountGroup,
  groupToEdit,
}: CreateEditAccountGroupDialogProps) => {
  const [name, setName] = useState(groupToEdit?.name || "");

  const cleanState = () => {
    setName("");
    onOpenChange(false);
  }

  useEffect(() => { 
      setName(groupToEdit?.name || "");
  }, [groupToEdit]);

  const handleSubmit = () => {
    if (groupToEdit) {
      onEditAccountGroup({
        ...groupToEdit,
        name: name.trim(),
      });
      cleanState();
      return;
    }

    onCreateAccountGroup(name.trim());
    cleanState();
  };

  const handleClose = () => {
    onOpenChange(false);
    cleanState();
  }

  const isValid = () => {
    return !name.trim();
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      title={groupToEdit ? "Redigera kontogrupp" : "Skapa ny kontogrupp"}
      footer={
        <div className="flex justify-end gap-4 pb-2 pr-2">
          <Button variant="outlined" onClick={() => handleClose()}>
            Avbryt
          </Button>
          <Button onClick={handleSubmit} disabled={isValid()}>
            {groupToEdit ? "Spara" : "Skapa"}
          </Button>
        </div>
      }
    >
      <div>
        <div className="py-2">
          <Input
            label="Namn"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>
    </Dialog >
  );
};